import '../chunk-STZMOEWR.mjs';

// src/ui/themes/dark.ts
var dark = {
  variables: {
    colorNeutral: "white",
    colorBackground: "#161618",
    colorForeground: "#EDEDEF",
    colorSecondary: "#7E7D86",
    colorSecondaryForeground: "#EDEDEF",
    colorShadow: "black"
  }
};

export { dark };
